import { useLang, sectionName } from "@/lib/i18n";
import { useEffect, useState } from "react";
import { useParams, useSearchParams } from "react-router-dom";
import LoadMoreFooter from "@/components/LoadMoreFooter";
import { api } from "@/lib/api";
import { NewsCard } from "@/components/NewsCard";
import { useInfiniteArticles } from "@/hooks/useInfiniteArticles";
import NotFoundPage from "@/pages/NotFoundPage";
import { sectionLabel } from "@/lib/sections";

export default function SectionPage() {
    const { slug } = useParams();
    const [sections, setSections] = useState([]);
    const [sp] = useSearchParams();
    const page = Math.max(1, parseInt(sp.get("page") || "1", 10) || 1);
    const feed = useInfiniteArticles({ section: slug, pageSize: 10, initialSkip: (page - 1) * 10, auto: false });
    const { items, loading } = feed;

    useEffect(() => {
        let alive = true;
        api.get("/public/sections").then((r) => { if (alive) setSections(r.data); });
        return () => { alive = false; };
    }, []);

    const sec = sections.find((s) => s.slug === slug);
    const { lang, t } = useLang();
    const title = sectionName(sec || { slug, name_ar: sectionLabel(slug) }, lang);
    useEffect(() => { document.title = `${title} | ${t("siteName")}`; }, [title, t]);
    if (sections.length > 0 && !sec) return <NotFoundPage />;

    return (
        <div className="mx-auto max-w-7xl px-4 py-8">
            <div className="mb-8 border-b border-gray-200 pb-4 flex items-center gap-3">
                <div className="h-10 w-1.5 rounded-sm bg-brand-red" />
                <h1 className="font-display font-black text-3xl md:text-4xl text-brand-black" data-testid="section-title">{title}</h1>
            </div>
            {items.length === 0 && loading ? (
                <p className="text-center text-gray-500 py-16" data-testid="section-loading">{t("loading")}</p>
            ) : items.length === 0 ? (
                <p className="text-center text-gray-500 py-16" data-testid="section-empty">{t("sectionEmpty")}</p>
            ) : (
                <>
                    <div className="news-grid grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6" data-testid="section-grid">
                        {items.map((a) => <NewsCard key={a.id} article={a} />)}
                    </div>
                    <LoadMoreFooter feed={feed} testId="section-load-more" />
                </>
            )}
        </div>
    );
}
